export const restoresConstants = {
  RESTORES_UPLOADING: '[Restores] Uploading',
  RESTORES_UPLOADING_SUCCESS: '[Restores] Uploading success',
  LOADING_RESTORES: '[Restores] Loading restores',
  LOADING_RESTORES_SUCCESS: '[Restores] Loading restores success',
  LOADING_RESTORES_FAILURE: '[Restores] Loading restores failure',
  UPDATE_INTERVENTIONS: '[Restores] Update interventions',
  UPDATE_INTERVENTIONS_SUCCESS: '[Restores] Update interventions success',
  UPDATE_INTERVENTIONS_FAILURE: '[Restores] Update interventions failure'
}
